import { render, staticRenderFns } from "./media.vue?vue&type=template&id=6055f3d5&scoped=true&"
import script from "./media.vue?vue&type=script&lang=js&"
export * from "./media.vue?vue&type=script&lang=js&"
import style0 from "./media.vue?vue&type=style&index=0&id=6055f3d5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6055f3d5",
  null
  
)

export default component.exports